// Forgot password component
import { useContext, useEffect, useState } from 'react';
import { useForm, useFieldArray, SubmitHandler } from "react-hook-form";
import { useNavigate } from 'react-router-dom';

import axios from 'axios';

import StateContext from '../stateContext';


function ForgotPassword() {

  const navigate = useNavigate();
  const { createNotification } = useContext(StateContext);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues: {
      email: ""
    }
  });

  function requestPasswordReset(passwordRequestData) {

    // make ajax call to reset password
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.post(
      '/api/account/passwordResetRequest',
      passwordRequestData
    ).then((response) => {
      if (response.status == 200 && response.data.success == true) {
        if (response.data.results > 0) {
          // reroute user to browse/home page with notification of email verification requirement
          navigate('/login/passwordResetRequest');
        } else {
          // no results
          createNotification({
          "status": "error",
          "msg": "Password reset request error!",
        })
        }
      } else {
        // prompt error 
        createNotification({
          "status": "error",
          "msg": "Password reset request error!",
        })
      }
    })
  }

  return (
    <form 
      onSubmit={handleSubmit(requestPasswordReset)}
      style={{
        height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"
      }}
    >
      <section
        style={{minWidth: "300px", display: "grid", gap: "10px", gridTemplateColumns: "auto", gridAutoRows: "auto auto", gridTemplateAreas: `"header header" "input btn"`}}
      >
        <h1 style={{gridArea: "header"}}>Forgot Password?</h1>
        <input 
          style={{gridArea: "input"}}
          {...register(`email`, 
          { required: true, pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: "Valid email address requiered!" } })} 
          placeholder='Enter Email Address' 
          style={ errors.email ? {border: "2px solid red"} : undefined}/>
        <button style={{gridArea: "btn"}} className="submit" type="submit">Reset Password</button>
      </section>
    </form>
  );
}

export default ForgotPassword;